import { createContext } from "react";

export interface AudioPlayerContextValue {
  sources: readonly AudioPlayerSource[];
  registerSourcesProvider: () => AudioPlayerSourcesProviderRegistration;

  currentSourceKey: string | undefined;
  /** Whether playback or seeking has explicitly positioned the playhead. */
  hasRequestedPosition: boolean;
  play: (sourceKey: string, time?: number) => void;
  seek: (sourceKey: string, time?: number) => void;

  nativeAudio: HTMLAudioElement | null;

  /** Timer mode of the control bar; shared so every rendered bar shows the same one. */
  timeDisplay: AudioPlayerTimeDisplay;
  setTimeDisplay: (timeDisplay: AudioPlayerTimeDisplay) => void;
}

export type AudioPlayerTimeDisplay = "elapsed" | "remaining";

export interface AudioPlayerSourcesProviderRegistration {
  onSourcesChange: (sources: readonly AudioPlayerSource[]) => void;
  unregister: () => void;
}

export interface AudioPlayerSource {
  key: string;
  title: string;
  sortTimestamp: number;
  fragmentTimes?: readonly number[];
  src: string | undefined;
}

export const AudioPlayerContext = createContext<AudioPlayerContextValue>({
  sources: [],
  registerSourcesProvider: () => ({
    onSourcesChange: () => {},
    unregister: () => {},
  }),

  currentSourceKey: undefined,
  hasRequestedPosition: false,
  play: () => {},
  seek: () => {},

  nativeAudio: null,

  timeDisplay: "elapsed",
  setTimeDisplay: () => {},
});
